import React from 'react'
import { connect } from 'react-redux'
import { withRouteData } from 'react-static'

import Trackable from './Trackable'
import MetaTags from './MetaTags'
import HeroIntent from '../components/HeroIntent'
import StickyMenu from '../components/StickyMenu'
import NewsPreview from '../components/NewsPreview'
import TryAnyIntent from '../components/TryAnyIntent'
import CatalogLight from '../components/CatalogLight'
import DevResources from '../components/DevResources'
import { getIntentProvidersAction, getNews } from '../connectors/redux/actions'

class AnyIntent extends React.Component {
    async componentDidMount() {
        const { dispatch, slug } = this.props
        await Promise.all([
            getIntentProvidersAction(slug)(dispatch), // required for child components
            getNews()(dispatch), // required for child components
        ])
    }

    render() {
        const { intent, getNews = {} } = this.props
        const name = intent.title || 'New Intent'
        const count = intent.providers.length + intent.countMore
        const title = `${name} - Intento Demo`
        const description = `${
            intent.description || ''
        } Access ${count} service providers via the single Intento API. Try it in the web interface. Register at https://console.inten.to for api keys!`
        const metatags = {
            title,
            description,
            og: {
                title,
                description,
                url: `https://inten.to/api-platform/${intent.url}`,
            },
            twitter: {
                title,
                description,
            },
        }

        if (intent.hasIntegrated) {
            return (
                <Trackable page={title}>
                    <MetaTags tags={metatags} />
                    <HeroIntent />
                    <StickyMenu />
                    <NewsPreview
                        news={getNews.news}
                        loading={getNews.pending}
                    />
                    <TryAnyIntent />
                    <CatalogLight />
                    <DevResources />
                </Trackable>
            )
        }

        // no demo, change order: catalog is up
        return (
            <Trackable page={title}>
                <MetaTags tags={metatags} />
                <HeroIntent />
                <StickyMenu />
                <NewsPreview news={getNews.news} loading={getNews.pending} />
                <CatalogLight />
                <DevResources />
            </Trackable>
        )
    }
}

function mapStateToProps(state) {
    return {
        getNews: state.getNews || {},
    }
}

export default connect(mapStateToProps)(withRouteData(AnyIntent))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/AnyIntent.jsx